export const experienceData = [
    {
        id: 1,
        company: 'TP-Link Systems Inc.',
        jobtitle: 'Cloud Operations Engineer II - R&D Cloud & Backend team',
        startYear: 'Oct 2026',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Amazon Web Services (AWS)',
        jobtitle: 'Cloud Support Engineer',
        startYear: 'Jun 2023',
        endYear: 'May 2026'
    },
    {
        id: 3,
        company: 'SproutLabs',
        jobtitle: 'Software Engineer',
        startYear: 'Jan 2023',
        endYear: 'Jun 2023'
    },
    {
        id: 4,
        company: 'Allstate Insurance',
        jobtitle: 'Licensed Sales Professional',
        startYear: 'Jun 2020',
        endYear: 'Sep 2021'
    },
]